export default "__VITE_ASSET__KjJ_FK1v__"